<template>
  <!-- 设置主管 -->
  <el-dialog v-dialogDrag title="设置主管" :visible.sync="setSuperShow" width="32%" class="dialogSetSuperPerson"
    :close-on-click-modal="false" :close-on-press-escape="false" @open="getPersonList" @close="setSuperShow = false">
    <div class="setSuperBody">
      <!-- 左侧找人 -->
      <div class="left">
        <el-input v-model="keyword" placeholder="请输入姓名/手机号" size="small" prefix-icon="el-icon-search" clearable>
        </el-input>
        <div class="personList">
          <div v-for="person in personSuperList" :key="person.userId" class="person" @click="setSuperPerson(person)">
            <el-image style="width: 16px; height: 16px" :src="require('@/CommonDP/assets/avatar.png')"></el-image>
            <span :title="`${person.name}(${person.phone})`">{{ person.name + '('+ person.phone+')' }}</span>
            <i v-if="person.isHead" class="el-icon-check"></i>
          </div>
        </div>
      </div>

      <!-- 右侧添加 -->
      <div class="right">
        <div class="checkedTitle">已选</div>
        <div class="checkedList">
          <div v-for="item in superSelectList" :key="item.userId" class="member">
            <el-image style="width: 15px; height: 15px" :src="require('@/CommonDP/assets/avatar.png')"></el-image>
            <span :title="`${item.name}(${item.phone})`">{{ item.name + '('+ item.phone+')' }}</span>
            <i class="el-icon-close" @click="cancelSuperPerson(item)"></i>
          </div>
        </div>
      </div>
    </div>

    <span slot="footer" class="dialog-footer">
      <el-button size="small" @click="setSuperShow = false">取 消</el-button>
      <el-button size="small" type="primary" @click="submitSuperSet">确 定</el-button>
    </span>
  </el-dialog>
</template>

<script>
import { mapState } from "vuex";
import orgFrameworkConfig from "@/CommonDP/service/org-service";

export default {
  components: {},
  props: {
    deptId: {
      type: String,
      default: () => ""
    }
  },
  data() {
    return {
      setSuperShow: false, // 设置主管弹框展示
      personSuperList: [], // 设置主管弹框，可选人员列表
      keyword: "", // 搜索框
      page: {
        pageSize: 0, // 全部
        pageNum: 1,
        totalCount: 0,
        pageLayout: "total, prev, pager, next,jumper" // 分页组件
      }
    };
  },
  computed: {
    ...mapState({
      enterpriseId: (state) => state.enterprise.enterpriseId
    }),

    // 设置主管弹框，右侧展示列表
    superSelectList() {
      const list = this.personSuperList.filter((item) => item.isHead) || [];
      return list;
    }
  },
  watch: {
    keyword() {
      this.$nextTick(() => {
        this.getPersonList();
      });
    }
  },
  mounted() {},
  methods: {
    // 部门下的人员列表
    getPersonList() {
      const params = {
        enterpriseId: this.enterpriseId,
        deptId: this.deptId,
        keyword: this.keyword,
        pageNum: this.page.pageNum,
        pageSize: this.page.pageSize,
        isQueryAll: 0
      };
      orgFrameworkConfig.orgUserQueryAllMemberList(params).then(({ data, totalCount }) => {
        this.page.totalCount = totalCount;
        this.personSuperList = data;
        this.personSuperList.map((item) => {
          for (const a of item.deptList) {
            a.rowID = this.deptId;
          }
        });
      });
    },

    // 设置主管人员
    setSuperPerson(person) {
      this.personSuperList.forEach((item) => {
        if (item.userId === person.userId) {
          item.isHead = item.isHead ? 0 : 1;
        }
      });
    },
    // 取消主管人员
    cancelSuperPerson(person) {
      this.personSuperList.forEach((item) => {
        if (item.userId === person.userId) {
          item.isHead = 0;
        }
      });
    },

    // 提交主管人员设置
    async submitSuperSet() {
      if (this.personSuperList.length === 0) {
        this.setSuperShow = false;
        return;
      }
      const userIds = this.superSelectList.map((item) => item.userId);
      const params = {
        deptId: this.deptId,
        userIds
      };
      await orgFrameworkConfig.addLeader(params);
      this.$message.success("设置主管成功");
      this.$emit("fetchData");
      this.setSuperShow = false;
    }
  }
};
</script>

<style lang='scss' scoped>
.setSuperBody {
  width: 100%;
  height: 450px;
  display: flex;
  justify-content: space-between;

  .left {
    width: 60%;
    height: 100%;

    .el-input {
      margin-bottom: 10px;
    }

    .personList {
      height: calc(100% - 40px);
      overflow-y: auto;

      .person {
        width: 100%;
        padding: 5px 15px;
        white-space: nowrap;

        display: flex;
        align-items: center;

        span {
          max-width: 180px;
          margin: 0 10px;
          font-size: 14px;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
        }
      }
    }

    .page {
      max-width: 350px;
      position: absolute;
      left: 15px;
      bottom: 15px;
    }
  }
  .right {
    width: 38%;
    height: 100%;
    padding: 0 10px;
    background: #f8fafe;

    .checkedTitle {
      font-family: "Arial Normal", "Arial", sans-serif;
      font-size: 14px;
      line-height: 32px;
      font-weight: 400;
      color: #aaaaaa;
    }

    .checkedList {
      width: 100%;
      padding: 5px 2px;
      height: calc(100% - 40px);
      overflow-y: auto;

      .member {
        width: 100%;
        padding: 7px 0;
        display: flex;
        justify-content: space-between;
        align-items: center;

        span {
          width: 1px;
          flex-grow: 1;
          margin-left: 10px;
          margin-right: 5px;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
        }

        i {
          cursor: pointer;
        }
      }
    }
  }
}
</style>

<style lang="scss">
.dialogSetSuperPerson {
  .el-dialog {
    border-radius: 4px !important;
  }

  .el-dialog__header {
    display: flex;
    justify-content: space-between;
    align-items: center;

    .el-dialog__title {
      font-family: "PingFang SC";
      font-weight: 700;
      font-size: 18px;
      line-height: 25px;
      color: var(--key-color);
    }

    .el-dialog__headerbtn {
      position: relative;
      top: 0 !important;
      right: 0 !important;
    }
  }

  .el-dialog__body {
    padding: 10px 20px !important;
  }

  .el-dialog__footer {
    padding: 10px 20px !important;
  }
}
</style>
